
import { Card } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

const PaymentSuccess = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dashboard-bg p-4">
      <Card className="w-full max-w-lg p-6 space-y-6 dashboard-card animate-fade-in">
        <div className="text-center space-y-4">
          <div className="h-28 w-32 mx-auto">
            <img 
              src="/lovable-uploads/57a7aaa6-bf38-4409-a65a-b5c45e8026c6.png" 
              alt="Mantle Logo" 
              className="h-full w-full object-contain"
            />
          </div>
          
          <div className="flex justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-dashboard-text-primary">
            Invoice Submitted Successfully!
          </h1>
          
          <p className="text-dashboard-text-secondary">
            Thank you for submitting your invoice. Our team will review it shortly.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
